import { useMutation } from '@tanstack/react-query';
import apiService from '../services/apiService';

export const useDeleteImage = () => {
  return useMutation({
    mutationFn: async ({ propertyId, imageId }) => {
      const response = await apiService.delete(
        `/api/properties/${propertyId}/images/${imageId}`
      );
      return response.data;
    },
  });
};
